<template>
	<div class="basis-1 overflow-y-auto rounded-lg bg-white p-4 dark:bg-gray-800 sm:basis-7/12">
		<BaseButton @click="submitCheck">Check Tax Rate</BaseButton>
		<LoadingSpinner v-if="loading" class="mt-2" text="Loading user data..." />
		<div v-if="preview" class="mt-2 pt-2">
			<table class="border-collapse border border-black">
				<tbody>
					<tr>
						<th class="border-collapse border border-black p-2">Tax Amount</th>
						<td class="border-collapse border border-black p-2">
							{{ preview.tax_amount }}
						</td>
					</tr>
					<tr>
						<th class="border-collapse border border-black p-2">Before Tax</th>
						<td class="border-collapse border border-black p-2">
							{{ preview.subtotal }}
						</td>
					</tr>
					<tr>
						<th class="border-collapse border border-black p-2">After Tax</th>
						<td class="border-collapse border border-black p-2">{{ preview.total }}</td>
					</tr>
					<tr>
						<th class="border-collapse border border-black p-2">Address</th>
						<td class="border-collapse border border-black p-2">
							{{ preview.address.address_line_1 }}
							{{ preview.address.address_line_2 }},
							{{ preview.address.address_city }},
							{{ preview.address.address_province }}
							{{ preview.address.address_postal_code }}
						</td>
					</tr>
				</tbody>
			</table>
			<table class="mt-2 border-collapse border border-black">
				<thead>
					<tr>
						<th class="border-collapse border border-black p-2">Authority</th>
						<th class="border-collapse border border-black p-2">Rate Type</th>
						<th class="border-collapse border border-black p-2">Rate</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="j in preview.jurisdictions" :key="j.authority">
						<td class="border-collapse border border-black p-2">{{ j.authority }}</td>
						<td class="border-collapse border border-black p-2">{{ j.rate_type }}</td>
						<td class="border-collapse border border-black p-2">{{ j.rate }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';

import LoadingSpinner from '@/components/ui/LoadingSpinner.vue';
import BaseButton from '@/components/ui/BaseButton.vue';

import { useRoute } from 'vue-router';
import { useApi } from '@/composables/useApi';

const route = useRoute();

const preview = ref(null);
const loading = ref(false);

const agentID = computed(() => {
	return route.params.agentID;
});

async function submitCheck() {
	loading.value = true;
	preview.value = null;

	const { data } = await useApi(`api/agents/${agentID.value}/billing/preview/`).json();

	preview.value = data.value;
	loading.value = false;
}
onMounted(async () => {});
</script>
